import { render, staticRenderFns } from "./ProfileTypeInput.vue?vue&type=template&id=48c6892c"
import script from "./ProfileTypeInput.vue?vue&type=script&lang=js"
export * from "./ProfileTypeInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports